import { Box, Container, Typography, Link, Grid, IconButton, TextField, Button, Stack, Divider } from '@mui/material';
import { Email, Phone, WhatsApp, LocationOn, LinkedIn, Twitter, Facebook, Instagram, YouTube } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { navItems } from '../../content/nav';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { Send } from 'lucide-react';
import { submitNewsletterSubscription } from '../../lib/api.js';
const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (!email || isSubmitting) return;

    try {
      setIsSubmitting(true);
      const result = await submitNewsletterSubscription({ email });
      enqueueSnackbar(result.message || 'Thank you for subscribing!', { variant: 'success' });
      setEmail('');
    } catch (error) {
      enqueueSnackbar(error.message || 'Unable to subscribe. Please try again.', { variant: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        background: 'rgba(11, 15, 26, 0.95)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        mt: 8,
        py: 8,
        position: 'relative',
        zIndex: 1,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6}>
          <Grid item xs={12} md={4}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <Box
                component={RouterLink}
                to="/"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: 1.5,
                  textDecoration: 'none',
                  mb: 2,
                  transition: 'transform 0.2s ease',
                  '&:hover': {
                    transform: 'scale(1.02)',
                  },
                }}
              >
                <Box
                  component="img"
                  src="/footerlogo.png"
                  alt="Swytrix Technologies"
                  onError={(e) => {
                    console.error('Footer logo image failed to load');
                    e.target.style.display = 'none';
                  }}
                  sx={{
                    width: { xs: 80, sm: 100, md: 120 },
                    height: { xs: 80, sm: 100, md: 120 },
                    objectFit: 'contain',
                    filter: 'drop-shadow(0 2px 8px rgba(168, 85, 247, 0.4)) brightness(1.1)',
                    transition: 'all 0.3s ease',
                    flexShrink: 0,
                    display: 'block',
                  }}
                />
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 800,
                    background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    whiteSpace: 'nowrap',
                    mt :"-30px",
                    display: 'block',
                    lineHeight: 1.2,
                  }}
                >
                  Swytrix Technologies LLC
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3, lineHeight: 1.8 }}>
                Enterprise-grade software development and IT solutions in United States. We help businesses transform their digital infrastructure with cutting-edge technology, 24/7 support, and same-day kickoff.
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
                <IconButton
                  component="a"
                  // href="https://www.linkedin.com/company/sandy-it-solution"
                  // href="#"
                  
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: '#a855f7',
                    border: '1px solid rgba(168, 85, 247, 0.3)',
                    '&:hover': {
                      background: 'rgba(168, 85, 247, 0.1)',
                      borderColor: '#a855f7',
                    },
                  }}
                  aria-label="LinkedIn"
                >
                  <LinkedIn />
                </IconButton>
                <IconButton
                  component="a"
                  // href="https://twitter.com/swytrixtech"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: '#a855f7',
                    border: '1px solid rgba(168, 85, 247, 0.3)',
                    '&:hover': {
                      background: 'rgba(168, 85, 247, 0.1)',
                      borderColor: '#a855f7',
                    },
                  }}
                  aria-label="Twitter"
                >
                  <Twitter />
                </IconButton>
                <IconButton
                  component="a"
                  // href="https://www.facebook.com/swytrixtech"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: '#a855f7',
                    border: '1px solid rgba(168, 85, 247, 0.3)',
                    '&:hover': {
                      background: 'rgba(168, 85, 247, 0.1)',
                      borderColor: '#a855f7',
                    },
                  }}
                  aria-label="Facebook"
                >
                  <Facebook />
                </IconButton>
                <IconButton
                  component="a"
                  // href="https://www.instagram.com/swytrixtech"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: '#a855f7',
                    border: '1px solid rgba(168, 85, 247, 0.3)',
                    '&:hover': {
                      background: 'rgba(168, 85, 247, 0.1)',
                      borderColor: '#a855f7',
                    },
                  }}
                  aria-label="Instagram"
                >
                  <Instagram />
                </IconButton>
                <IconButton
                  component="a"
                  // href="https://www.youtube.com/@swytrixtech"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: '#a855f7',
                    border: '1px solid rgba(168, 85, 247, 0.3)',
                    '&:hover': {
                      background: 'rgba(168, 85, 247, 0.1)',
                      borderColor: '#a855f7',
                    },
                  }}
                  aria-label="YouTube"
                >
                  <YouTube />
                </IconButton>
              </Box>
            </motion.div>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                Quick Links
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    component={RouterLink}
                    to={item.path}
                    sx={{
                      color: 'text.secondary',
                      textDecoration: 'none',
                      fontSize: '0.875rem',
                      transition: 'all 0.3s ease',
                      '&:hover': { color: '#a855f7', transform: 'translateX(5px)' },
                    }}
                  >
                    {item.label}
                  </Link>
                ))}
              </Box>
            </motion.div>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                Services
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {[
                  'Web & Mobile Development',
                  'Cloud Solutions',
                  'DevOps & CI/CD',
                  'Cybersecurity',
                  // 'AI/ML Solutions',
                  'ERP/CRM',
                  'E-commerce',
                  'IT Support',
                ].map((service) => (
                  <Link
                    key={service}
                    component={RouterLink}
                    to="/services"
                    sx={{
                      color: 'text.secondary',
                      textDecoration: 'none',
                      fontSize: '0.875rem',
                      transition: 'all 0.3s ease',
                      '&:hover': { color: '#a855f7', transform: 'translateX(5px)' },
                    }}
                  >
                    {service}
                  </Link>
                ))}
              </Box>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={3}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                Contact Info
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'start', gap: 1 }}>
                  <LocationOn sx={{ color: '#a855f7', fontSize: 20, mt: 0.5 }} />
                  <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                  30N Gould St Ste R, Sheridan, WY 82801 United States
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Email sx={{ color: '#a855f7', fontSize: 20 }} />
                  <Link
                    href="mailto:info@swytrixtech.com"
                    sx={{
                      color: 'text.secondary',
                      textDecoration: 'none',
                      fontSize: '0.875rem',
                      '&:hover': { color: '#a855f7' },
                    }}
                  >
                    info@swytrixtech.com
                  </Link>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Phone sx={{ color: '#a855f7', fontSize: 20 }} />
                  <Link
                    href="tel:+18166000410"
                    sx={{
                      color: 'text.secondary',
                      textDecoration: 'none',
                      fontSize: '0.875rem',
                      '&:hover': { color: '#a855f7' },
                    }}
                  >
                    +18166000410
                  </Link>
                </Box>
                {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <WhatsApp sx={{ color: '#a855f7', fontSize: 20 }} />
                  <Link
                    href="https://wa.me/18166000410"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: 'text.secondary',
                      textDecoration: 'none',
                      fontSize: '0.875rem',
                      '&:hover': { color: '#a855f7' },
                    }}
                  >
                    WhatsApp Us
                  </Link>
                </Box> */}
              </Box>

              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, fontSize: '1rem' }}>
                Newsletter
              </Typography>
              <Box component="form" onSubmit={handleNewsletterSubmit}>
                <Stack direction="row" spacing={1}>
                  <TextField
                    type="email"
                    placeholder="Your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    size="small"
                    required
                    sx={{
                      flex: 1,
                      '& .MuiOutlinedInput-root': {
                        background: 'rgba(255, 255, 255, 0.05)',
                        color: 'white',
                        '& fieldset': {
                          borderColor: 'rgba(255, 255, 255, 0.3)',
                        },
                        '&:hover fieldset': {
                          borderColor: '#a855f7',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#a855f7',
                        },
                      },
                      '& .MuiInputBase-input': {
                        fontSize: '0.875rem',
                      },
                    }}
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={isSubmitting}
                    sx={{
                      background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
                      minWidth: 'auto',
                      px: 2,
                      '&:hover': {
                        background: 'linear-gradient(135deg, #9333ea 0%, #db2777 100%)',
                      },
                    }}
                  >
                    {isSubmitting ? 'Sending...' : <Send size={18} />}
                  </Button>
                </Stack>
              </Box>
            </motion.div>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary" textAlign="center">
            © {currentYear} Swytrix Technologies LLC. All rights reserved. United States.
          </Typography>
          <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Link
              component={RouterLink}
              to="/privacy-policy"
              sx={{
                color: 'text.secondary',
                textDecoration: 'none',
                fontSize: '0.875rem',
                '&:hover': { color: '#a855f7' },
              }}
            >
              Privacy Policy
            </Link>
            <Link
              component={RouterLink}
              to="/terms-of-service"
              sx={{
                color: 'text.secondary',
                textDecoration: 'none',
                fontSize: '0.875rem',
                '&:hover': { color: '#a855f7' },
              }}
            >
              Terms of Service
            </Link>
            <Link
              component={RouterLink}
              to="/cookie-policy"
              sx={{
                color: 'text.secondary',
                textDecoration: 'none',
                fontSize: '0.875rem',
                '&:hover': { color: '#a855f7' },
              }}
            >
              Cookie Policy
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
export default Footer;